import { type BoardTask } from '../../../../../common/types/task';
import { type BoardTasksState } from '../tasksSlice';

// Добавление новой задачи в кэш-стейт задач, без вставки в колонку
export const add = (state: BoardTasksState, task: BoardTask) => {
  const existing = state.byId[task.id];

  if (!existing) {
    if (!task.status) return;

    state.byId[task.id] = task;

    return;
  }
};
